import React, { useState } from "react";
import "./BuildCourageInterior.css";

import InteriorWhite from "../../assets/images/buildCourage/interiorWhiteGray.webp";
import InteriorBlack from "../../assets/images/buildCourage/interiorBlueBlack.webp";
import InteriorGrey from "../../assets/images/buildCourage/interiorGradientBlue.webp";

const BuildCourageInterior = ({ onInteriorChange }) => {
  
  const interiorOptions = [
    { id: "white-grey", label: "White / Grey", image: InteriorWhite, dotColor: "#dfe3e6" },
    { id: "black", label: "Black", image: InteriorBlack, dotColor: "#2a2a2a" },
    { id: "grey", label: "Grey", image: InteriorGrey, dotColor: "#585858" }
  ];

  const [selectedInteriorId, setSelectedInteriorId] = useState(interiorOptions[0].id);

  const selectedInterior = interiorOptions.find((x) => x.id === selectedInteriorId);

  const handleSelectInterior = (id) => {
    setSelectedInteriorId(id);
    const selected = interiorOptions.find((x) => x.id === id);
    if (onInteriorChange) onInteriorChange(selected);
  };

  return (
    <section className="build-int-wrapper">
      <h2 className="build-int-title">Choose interior color</h2>

      <div className="build-int-dots-row">
        {interiorOptions.map((opt) => (
          <button
            key={opt.id}
            className={`int-dot-btn ${selectedInteriorId === opt.id ? "active" : ""}`}
            onClick={() => handleSelectInterior(opt.id)}
          >
            <span className="int-dot-color" style={{ backgroundColor: opt.dotColor }} />
          </button>
        ))}
      </div>

      <div className="build-int-image-wrapper">
        <img src={selectedInterior.image} alt={selectedInterior.label} className="build-int-image" />
      </div>
    </section>
  );
};

export default BuildCourageInterior;
